// src/utils/constants/library-info.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var LIBRARY_NAME = "@JohnLewisPartnership/jl-analytics-event-stream";
var LIBRARY_VERSION = "3.0.2";
var LIBRARY_DESCRIPTION = "".concat(LIBRARY_NAME, " v").concat(LIBRARY_VERSION);
// src/utils/window-tools/window-tools.ts
var isWindowDefined = function() {
    return typeof window !== "undefined";
};
var getLanguage = function() {
    return window.navigator.language;
};
var getURL = function() {
    return window.location.href;
};
var getPageTitle = function() {
    return document.title;
};
var getPageReferrer = function() {
    return document.referrer;
};
var getDeviceType = function() {
    var userAgent = window.navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent)) {
        if (/tablet|ipad/.test(userAgent)) {
            return "tablet";
        }
        return "mobile";
    }
    return "desktop";
};
var getDeviceOS = function() {
    var _window_navigator_userAgentData;
    var _window_navigator_userAgentData_platform;
    return (_window_navigator_userAgentData_platform = (_window_navigator_userAgentData = window.navigator.userAgentData) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) !== null && _window_navigator_userAgentData_platform !== void 0 ? _window_navigator_userAgentData_platform : window.navigator.platform;
};
var getDeviceBrowser = function() {
    var _window_navigator_userAgentData;
    var userAgent = window.navigator.userAgent;
    if (userAgent.indexOf("Chrome") !== -1) {
        return "Chrome";
    } else if (userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1) {
        return "Safari";
    } else if (userAgent.indexOf("Firefox") !== -1) {
        return "Firefox";
    } else if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1) {
        return "Internet Explorer";
    } else if (userAgent.indexOf("Edge") !== -1 || userAgent.indexOf("Edg/") !== -1) {
        return "Edge";
    }
    var brands = (_window_navigator_userAgentData = window.navigator.userAgentData) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands;
    if (brands && Array.isArray(brands)) {
        var realBrand = brands.find(function(brand) {
            return brand.brand !== "Not A Brand" && brand.brand !== "Not_A Brand" && !brand.brand.startsWith("Not");
        });
        if (realBrand) {
            return realBrand.brand;
        }
    }
    return window.navigator.appName;
};
var getDeviceBrowserVersion = function() {
    var userAgent = window.navigator.userAgent;
    var version = "";
    if (userAgent.indexOf("Chrome") !== -1) {
        var _userAgent_match;
        version = ((_userAgent_match = userAgent.match(/Chrome\/([0-9]+\.[0-9]+)/)) === null || _userAgent_match === void 0 ? void 0 : _userAgent_match[1]) || "";
    } else if (userAgent.indexOf("Safari") !== -1 && userAgent.indexOf("Chrome") === -1) {
        var _userAgent_match1;
        version = ((_userAgent_match1 = userAgent.match(/Version\/([0-9]+\.[0-9]+)/)) === null || _userAgent_match1 === void 0 ? void 0 : _userAgent_match1[1]) || "";
    } else if (userAgent.indexOf("Firefox") !== -1) {
        var _userAgent_match2;
        version = ((_userAgent_match2 = userAgent.match(/Firefox\/([0-9]+\.[0-9]+)/)) === null || _userAgent_match2 === void 0 ? void 0 : _userAgent_match2[1]) || "";
    } else if (userAgent.indexOf("MSIE") !== -1) {
        var _userAgent_match3;
        version = ((_userAgent_match3 = userAgent.match(/MSIE ([0-9]+\.[0-9]+)/)) === null || _userAgent_match3 === void 0 ? void 0 : _userAgent_match3[1]) || "";
    } else if (userAgent.indexOf("Trident/") !== -1) {
        var _userAgent_match4;
        version = ((_userAgent_match4 = userAgent.match(/rv:([0-9]+\.[0-9]+)/)) === null || _userAgent_match4 === void 0 ? void 0 : _userAgent_match4[1]) || "";
    } else if (userAgent.indexOf("Edge") !== -1) {
        var _userAgent_match5;
        version = ((_userAgent_match5 = userAgent.match(/Edge\/([0-9]+\.[0-9]+)/)) === null || _userAgent_match5 === void 0 ? void 0 : _userAgent_match5[1]) || "";
    } else if (userAgent.indexOf("Edg/") !== -1) {
        var _userAgent_match6;
        version = ((_userAgent_match6 = userAgent.match(/Edg\/([0-9]+\.[0-9]+)/)) === null || _userAgent_match6 === void 0 ? void 0 : _userAgent_match6[1]) || "";
    }
    return version || "unknown";
};
var getDeviceUserAgent = function() {
    return window.navigator.userAgent;
};
// src/utils/logging/logging.ts
var getSessionStorageDebugValue = function(name) {
    if (!isWindowDefined()) return false;
    try {
        var _window_sessionStorage, _window;
        return !!((_window = window) === null || _window === void 0 ? void 0 : (_window_sessionStorage = _window.sessionStorage) === null || _window_sessionStorage === void 0 ? void 0 : _window_sessionStorage.getItem(name));
    } catch (e) {
        console.warn(LIBRARY_NAME + ": Could not access sessionStorage for debugging flag.", e);
        return false;
    }
};
var isDebugMode = function() {
    return getSessionStorageDebugValue("DEBUG_ANALYTICS");
};
var errorHandler = function(title, detail, data) {
    var throwError = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (!isDebugMode()) return;
    var message = formatMessage(title, detail);
    if (throwError) {
        throw new Error(message);
    } else {
        printMessage(message, data);
    }
};
var logHandler = function(title, detail, data) {
    if (!isDebugMode()) return;
    var message = formatMessage(title, detail);
    printMessage(message, data);
};
var printMessage = function(message, data) {
    data ? console.log(message, data) : console.log(message);
};
var formatMessage = function(title, detail) {
    return "".concat(LIBRARY_NAME, " - ").concat(title, ": ").concat(detail);
};
logHandler(LIBRARY_DESCRIPTION, "");
// src/utils/cookies/cookies.ts
var getCookieValue = function(name) {
    if (typeof document === "undefined") {
        return null;
    }
    if (!name || typeof name !== "string" || name.trim() === "") {
        return null;
    }
    var encodedName = encodeURIComponent(name);
    var nameEQ = encodedName + "=";
    var rawCookie = document.cookie;
    if (typeof rawCookie !== "string") return null;
    var ca = rawCookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        if (typeof c === "string") {
            while(c.charAt(0) === " "){
                c = c.substring(1, c.length);
            }
        } else {
            continue;
        }
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
};
// src/tracking/events/BaseEvent.ts
var getBaseEventHiddenDefaults = function() {
    return {
        timestamp: Date.now(),
        libraryVersion: LIBRARY_VERSION,
        libraryName: LIBRARY_NAME,
        jlUUID: getCookieValue("jl_uuid"),
        device: {
            type: getDeviceType(),
            os: getDeviceOS(),
            browser: getDeviceBrowser(),
            browserVersion: getDeviceBrowserVersion(),
            userAgent: getDeviceUserAgent()
        },
        page: {
            url: getURL(),
            title: getPageTitle(),
            referrer: getPageReferrer(),
            locale: {
                language: getLanguage()
            }
        }
    };
};
var getBaseEventDefaults = function() {
    return {
    };
};
// src/utils/recursive-merge/recursive-merge.ts
var recursiveMerge = function(oldObject, newObject) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    options.isMergeableObject = options.isMergeableObject || canMergeObject;
    options.cloneUnlessOtherwiseSpecified = cloneIfNeeded;
    var sourceIsArray = Array.isArray(newObject);
    var targetIsArray = Array.isArray(oldObject);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) {
        return cloneIfNeeded(newObject, options);
    } else if (sourceIsArray) {
        return replaceArray(newObject, options);
    } else {
        return mergeObjects(oldObject, newObject, options);
    }
};
var isObject = function(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object";
};
var isRegExpOrDate = function(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]";
};
var isSpecialValue = function(value) {
    return isRegExpOrDate(value) || isReactElement(value);
};
var isReactElement = function(value) {
    var canUseSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
    return value.$$typeof === REACT_ELEMENT_TYPE;
};
var canMergeObject = function(value) {
    return isObject(value) && !isSpecialValue(value);
};
var createEmptyTarget = function(val) {
    return Array.isArray(val) ? [] : {};
};
var cloneIfNeeded = function(value, options) {
    return options.clone !== false && canMergeObject(value) ? recursiveMerge(createEmptyTarget(value), value, options) : value;
};
var replaceArray = function(source, options) {
    return source.map(function(element) {
        return cloneIfNeeded(element, options);
    });
};
var selectMergeFunction = function(key, options) {
    if (!options.customMerge) {
        return recursiveMerge;
    }
    var customMerge2 = options.customMerge(key);
    return typeof customMerge2 === "function" ? customMerge2 : recursiveMerge;
};
var getSymbols = function(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
};
var getAllKeys = function(target) {
    return _to_consumable_array(Object.keys(target)).concat(_to_consumable_array(getSymbols(target)));
};
var hasProperty = function(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
};
var isUnsafeProperty = function(target, key) {
    return hasProperty(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
};
var mergeObjects = function(target, source, options) {
    var destination = {};
    if (canMergeObject(target)) {
        getAllKeys(target).forEach(function(key) {
            destination[key] = cloneIfNeeded(target[key], options);
        });
    }
    getAllKeys(source).forEach(function(key) {
        if (isUnsafeProperty(target, key)) {
            return;
        }
        if (hasProperty(target, key) && canMergeObject(source[key])) {
            destination[key] = selectMergeFunction(key, options)(target[key], source[key], options);
        } else {
            destination[key] = cloneIfNeeded(source[key], options);
        }
    });
    return destination;
};
// src/utils/pii-redactor/pii-redactor.ts
var redactPII = function(text) {
    if (typeof text !== "string") return text;
    var piiRegEx = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)|(name|&e|mail|email|phone|mobile|tel|contactnumber|contact|password|billingpostcode|billingpostalcode|postalcode|postcode|zipcode|zip)(=)([^&]*)/gim;
    var decodedText;
    try {
        decodedText = decodeURIComponent(text);
    } catch (error) {
        decodedText = text;
    }
    return decodedText.replace(piiRegEx, "$2$3[REDACTED]");
};
// src/utils/constants/constants.ts
var JL_ANALYTICS_EVENT_STREAM_CUSTOM_EVENT = "jl-analytics-event-stream";
// src/tracking/services/ensighten/ensighten.ts
var sendToEnsightenServerSide = function(eventName, data) {
    logHandler("sendToEnsightenServerSide", 'Dispatching Analytics Event "'.concat(eventName, '".'), data);
    var eventData = {
        detail: {
            eventName: eventName,
            data: data
        }
    };
    window.dispatchEvent(new CustomEvent(JL_ANALYTICS_EVENT_STREAM_CUSTOM_EVENT, eventData));
    logHandler("sendToEnsightenServerSide", 'Final object sent to Ensighten for "'.concat(eventName, '".'), eventData);
};
// src/tracking/track-event/track-event.ts
var BOOTSTRAPPER_READY_EVENT = "EnsightenReady";
var queue = [];
var isListeningForReadyEvent = false;
var isBootstrapperReady = false;
var trackEvent = function(event, payload) {
    if (!event) {
        errorHandler("trackEvent", "Event is required and must be chosen from the list of events.");
        return;
    }
    logHandler("trackEvent", '"'.concat(event.name, '" received payload.'), {
        payload: payload
    });
    var visibleDefaults = recursiveMerge(getBaseEventDefaults(), event.defaults);
    logHandler("trackEvent", '"'.concat(event.name, '" visibleDefaults.'), {
        payload: visibleDefaults
    });
    var payloadOverrideVisibleDefaults = recursiveMerge(visibleDefaults, payload);
    logHandler("trackEvent", '"'.concat(event.name, '" payloadOverrideVisibleDefaults.'), {
        payload: payloadOverrideVisibleDefaults
    });
    var hiddenDefaultsOverridePayload = recursiveMerge(payloadOverrideVisibleDefaults, getBaseEventHiddenDefaults());
    logHandler("trackEvent", '"'.concat(event.name, '" hiddenDefaultsOverridePayload.'), {
        payload: hiddenDefaultsOverridePayload
    });
    recursivelyLoopOverProperties(hiddenDefaultsOverridePayload);
    forwardEvent(event.name, hiddenDefaultsOverridePayload);
};
var recursivelyLoopOverProperties = function(eventPayload) {
    if (!eventPayload || (typeof eventPayload === "undefined" ? "undefined" : _type_of(eventPayload)) !== "object") {
        return;
    }
    for(var key in eventPayload){
        if (Object.prototype.hasOwnProperty.call(eventPayload, key)) {
            var value = eventPayload[key];
            if (typeof value === "string") {
                eventPayload[key] = redactPII(value);
            } else if (value !== null && (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object") {
                recursivelyLoopOverProperties(value);
            }
        }
    }
};
var forwardEvent = function(eventName, data) {
    logHandler("forwardEvent", "Forwarding event.");
    if (isBootstrapperReady || checkForBootstrapper()) {
        logHandler("forwardEvent", "Found Bootstrapper.");
        sendToEnsightenServerSide(eventName, data);
    } else {
        queue.push({
            eventName: eventName,
            data: data
        });
        logHandler("forwardEvent", "Bootstrapper not found - pushing to queue.", queue);
        if (!isListeningForReadyEvent) {
            logHandler("forwardEvent", "Was not yet listening for bootstrap ready event.");
            listenForBootstrapperReadyEvent();
        }
    }
};
var listenForBootstrapperReadyEvent = function() {
    isListeningForReadyEvent = true;
    if (isBootstrapperReady || checkForBootstrapper()) {
        flushQueue();
    } else {
        logHandler("listenForBootstrapperReadyEvent", "Starting to listen for Bootstrapper ready event.");
        if (isWindowDefined()) {
            logHandler("listenForBootstrapperReadyEvent", "Window is defined so adding ready listener.");
            window.addEventListener(BOOTSTRAPPER_READY_EVENT, function() {
                logHandler(BOOTSTRAPPER_READY_EVENT, "Ensighten ready event fired.");
                flushQueue();
            }, {
                once: true,
                capture: true
            });
            logHandler("listenForBootstrapperReadyEvent", "Listening for Ensighten ready event.");
        } else {
            isListeningForReadyEvent = false;
            logHandler("listenForBootstrapperReadyEvent", "Window is undefined so cannot add ready listener.");
        }
    }
};
var checkForBootstrapper = function() {
    if (!isWindowDefined()) return false;
    isBootstrapperReady = window.Bootstrapper && window.Bootstrapper.dataStateChangeReady;
    return isBootstrapperReady;
};
var flushQueue = function() {
    logHandler("flushQueue", "Started flushing queue.", queue);
    while(queue.length){
        var event = queue.shift();
        if (event) {
            forwardEvent(event.eventName, event.data);
        }
    }
    logHandler("flushQueue", "Finished flushing queue.", queue);
};
// src/tracking/events/public/AddToBasket/AddToBasket.ts
var AddToBasket = {
    name: "AddToBasket",
    defaults: {}
};
// src/tracking/events/public/NonImportedEvent/NonImportedEvent.ts
var NonImportedEvent = {
    name: "NonImportedEvent",
    defaults: {
        testFieldToSeeImport2: "gbp"
    }
};
// src/data-layer/update-data-layer/update-data-layer.ts
var updateDataLayer = function(partialDataLayer) {
    if (!partialDataLayer) return;
    var options = {
        customMerge: customMerge
    };
    var defaultData = {
        page: {
            locale: {
                country: "uk",
                currency: "gbp",
                language: "en-gb"
            },
            pageInfo: {
                site: "johnlewis.com"
            }
        }
    };
    var _window_jlData;
    var existingData = (_window_jlData = window.jlData) !== null && _window_jlData !== void 0 ? _window_jlData : {};
    logHandler("------------------ STARTING DATA LAYER UPDATE ---------------------", "");
    logHandler("Data Layer Update", "default data layer", defaultData);
    logHandler("Data Layer Update", "existing data layer from window.jlData", existingData);
    var currentJLData = recursiveMerge(existingData, defaultData, options);
    logHandler("Data Layer Update", "merging existing & default data layers", currentJLData);
    var newDataLayer = recursiveMerge(currentJLData, partialDataLayer, options);
    logHandler("Data Layer Update", "merging existing + default with new partial data layer", newDataLayer);
    window.jlData = newDataLayer;
    logHandler("------------------ FINISHED DATA LAYER UPDATE ---------------------", "");
};
var customMerge = function(key) {
    if (key === "promotionClassifications") {
        return mergePromoClassifications;
    }
    return;
};
var mergePromoClassifications = function(_currentPromoClassifications, newPromoClassifications) {
    return newPromoClassifications;
};
// src/public.ts
listenForBootstrapperReadyEvent();
export { AddToBasket, JL_ANALYTICS_EVENT_STREAM_CUSTOM_EVENT, NonImportedEvent, trackEvent, updateDataLayer };
